import styled from 'styled-components';
import { themeColor } from '@hud/web-components/theme/colors';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionButton = styled.button`
  margin-left: 10px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
`;

export const NotificationIcon = styled(HudIcon)<{ iconColor: string }>`
  border-radius: 4px;
  color: ${themeColor('buttonBackground')};
  background-color: ${({ iconColor }) => themeColor(iconColor)};
  filter: drop-shadow(0 0 5px ${({ iconColor }) => themeColor(iconColor)});
`;
